import React from 'react'

export const ProtocolsCreatePage = () => {
  return <>({`ProtocolsCreatePage`})</>
}
